<template>
  <el-dialog title="添加数据" :visible.sync="show" width="80%" custom-class="json-child-list-setter-dialog" append-to-body>
    <div class="app-toolbar1">
      <el-button size="small" @click="toAdd()" type="primary">添加一级菜单</el-button>
    </div>
    <el-tree :data="menus" node-key="id" :default-expand-all="true" :expand-on-click-node="false" @node-click="toUpdate" v-loading="loading" class="menu-manage-tree" ref="tree">
      <span slot-scope="{ node, data }" class="menu-manage-node">
        <span>{{ data.name }}</span>
        <div class="menu-manage-buttons">
          <el-button type="text" size="mini" v-if="!data.parentId" @click.stop.prevent="toAdd(data.id, data.name)">添加二级菜单</el-button>
          <el-button type="text" size="mini" @click.stop.prevent="toDelete(data)">删除</el-button>
        </div>
      </span>
    </el-tree>
    <el-dialog :title="formTitle" :visible.sync="showForm" @close="resetForm" append-to-body>
      <el-form :model="form" ref="form" :status-icon="true" label-position="top">
        <el-form-item label="上级菜单" prop="parentName">
          <el-input v-model="form.parentName" :readonly="true"></el-input>
        </el-form-item>
        <el-form-item v-for="column in columns" :label="column.name" :key="column.name">
          <el-input v-model="form[column.field]" placeholder="请输入" :maxlength="40"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showForm = false">取 消</el-button>
        <el-button type="primary" @click="doSaveTree">保 存</el-button>
      </div>
    </el-dialog>
    <div slot="footer">
      <el-button size="mini" @click="show = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="doSave">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'json-child-list-setter-dialog',
  data () {
    return {
      show: false,
      datas: [],
      columns: [],
      loading: false,
      menus: [],
      showForm: false,
      formTitle: '添加一级菜单',
      form: {
        parentId: null,
        parentName: ''
      }
    }
  },
  methods: {
    open (columns, datas) {
      this.findChildren(JSON.parse(JSON.stringify(datas)))
      this.menus = datas
      this.columns = columns
      this.show = true
    },
    findChildren (arr) {
      if (!arr.length) return
      arr.forEach(c => {
        this.datas.push(c)
        if (c.children) {
          this.findChildren(c.children)
          delete c.children
        }
      })
    },
    toAdd (parentId, parentName) {
      this.formTitle = !parentId ? '添加一级菜单' : '添加二级菜单'
      this.form = {parentId: parentId || '', parentName: parentName || ''}
      this.columns.forEach(c => { this.form[c.field] = '' })
      this.showForm = true
    },
    toUpdate (menu) {
      this.formTitle = '修改菜单'
      this.form = {id: menu.id, parentId: menu.parentId, parentName: menu.parentName}
      this.columns.forEach(c => { this.form[c.field] = menu[c.field] })
      this.showForm = true
    },
    toDelete (menu) {
      this.$confirm('您确认要删除该菜单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.datas.splice(this.datas.findIndex(item => item.id === menu.id), 1)
        this.buildTree(JSON.parse(JSON.stringify(this.datas)))
      })
    },
    doSaveTree () {
      let { id, parentId, parentName } = this.form
      if (id) {
        let i = this.datas.findIndex(item => item.id === id)
        this.datas[i] = { id, parentId, parentName }
        this.columns.forEach(c => { this.datas[i][c.field] = this.form[c.field] })
      } else {
        let obj = { parentId, parentName, id: new Date().getTime() }
        this.columns.forEach(c => { obj[c.field] = this.form[c.field] })
        this.datas.push(obj)
      }
      this.buildTree(JSON.parse(JSON.stringify(this.datas)))
      this.showForm = false
    },
    doSave () {
      this.$emit('save', this.menus)
      this.show = false
    },
    buildTree (depts) {
      let deptMap = {}
      let result = []
      for (let dept of depts) {
        deptMap[dept.id] = dept
        if (dept.parentId === '') {
          result.push(dept)
        }
      }
      for (let dept of depts) {
        let parentDept = deptMap[dept.parentId]
        if (!parentDept) {
          continue
        }
        let children = parentDept.children || []
        children.push(dept)
        parentDept.children = children
      }
      this.menus = result
    },
    resetForm () {
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style>
.json-child-list-setter-dialog .el-dialog__body{padding:0;margin-top:10px;border-top:1px solid #ebeef5;}
</style>
